export default __webpack_public_path__ + "static/media/submit.a33dbee4.png";